import { render, staticRenderFns } from "./productDialog.vue?vue&type=template&id=11ea710d&scoped=true&"
import script from "./productDialog.vue?vue&type=script&lang=js&"
export * from "./productDialog.vue?vue&type=script&lang=js&"
import style0 from "./productDialog.vue?vue&type=style&index=0&id=11ea710d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11ea710d",
  null
  
)

export default component.exports